import {ConnectionStatus, ConnectionStatusDisplay} from "../../types/connection"

interface DeviceCardHeaderProps {
	deviceId: string
	isLiveMode: boolean
	statusDisplay: ConnectionStatusDisplay
	lastUpdateTime: Date | null
	isFavorite: boolean
	showShadowData: boolean
	onToggleFavorite: () => void
	onToggleShadow: () => void
	onRefresh: () => void
	getTimeSinceLastUpdate: () => string
}

export const DeviceCardHeader = ({
	deviceId,
	isLiveMode,
	statusDisplay,
	lastUpdateTime,
	isFavorite,
	showShadowData,
	onToggleFavorite,
	onToggleShadow,
	onRefresh,
	getTimeSinceLastUpdate,
}: DeviceCardHeaderProps) => (
	<div className="flex flex-col gap-2 mb-4">
		<div className="flex flex-wrap justify-between items-start gap-2">
			<div className="flex flex-col gap-1 min-w-0">
				<h3 className="font-semibold text-lg flex items-center gap-2 text-gray-900 dark:text-white">
					{deviceId}
					{isLiveMode && (
						<span className="w-2 h-2 bg-blue-500 rounded-full animate-pulse shrink-0" />
					)}
				</h3>
				<div className="flex items-center gap-2">
					<span className="text-sm text-gray-500 dark:text-gray-400">Status:</span>
					<div
						className={`px-2 py-1 rounded text-xs font-medium flex items-center gap-1 ${statusDisplay.className}`}>
						{statusDisplay.icon}
						<span>{statusDisplay.text}</span>
					</div>
				</div>
				{lastUpdateTime && (
					<div className="text-xs text-gray-500 dark:text-gray-400">
						Last shadow update: {getTimeSinceLastUpdate()}
						{isLiveMode && <span className="text-blue-500 dark:text-blue-400"> (Live)</span>}
					</div>
				)}
			</div>
			<div className="flex gap-2 shrink-0">
				<button
					onClick={onToggleFavorite}
					title={isFavorite ? "Remove from favorites" : "Add to favorites"}
					className={`px-3 py-1 rounded text-sm font-medium transition-colors ${
						isFavorite
							? "bg-yellow-100 dark:bg-yellow-900/40 text-yellow-700 dark:text-yellow-300 hover:bg-yellow-200 dark:hover:bg-yellow-900/60"
							: "bg-gray-100 dark:bg-gray-700 text-gray-500 dark:text-gray-400 hover:bg-yellow-100 dark:hover:bg-yellow-900/40 hover:text-yellow-700 dark:hover:text-yellow-300"
					}`}>
					{isFavorite ? "⭐" : "☆"}
				</button>
				<button
					onClick={onToggleShadow}
					className="px-3 py-1 bg-gray-500 hover:bg-gray-600 dark:bg-gray-600 dark:hover:bg-gray-500 text-white rounded text-sm">
					{showShadowData ? "Hide" : "Show"} Shadow
				</button>
				<button
					onClick={onRefresh}
					className="px-3 py-1 bg-blue-500 hover:bg-blue-600 dark:bg-blue-600 dark:hover:bg-blue-500 text-white rounded text-sm">
					Refresh
				</button>
			</div>
		</div>
	</div>
)
